import React from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const KPICard = ({
  title,
  valueField,
  icon,
  trend,
  up,
  subtitle,
  graphData,
  color = "#6366f1",
  onClick,
  loadingMap,
  dataMap
}) => {
  const isUp = up ?? !String(trend).startsWith("-");

  console.log("loadingMap--", loadingMap, dataMap, dataMap?.["Net Profit"]?.[0]?.["NetProfit"]);

  // const apiValue = dataMap?.[title]?.[0]?.[valueField];
  // const displayValue = apiValue ?? ""; // use API value if available, else static fallback


  // --- DYNAMIC TOTAL CALCULATION ---
  let displayValue = "";

  if (dataMap?.[title]) {
    const rawData = dataMap[title];

    if (title === "Daily Sales" && Array.isArray(rawData)) {
      // 1. Reduce the array to calculate the dynamic grand total across all branches
      const totalNet = rawData.reduce((sum, branch) => sum + (branch[valueField] || 0), 0);
      
      // 2. Format to currency structure (e.g., 5,932.99)
      displayValue = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(totalNet);
    } else if (title === "Net Profit" && Array.isArray(rawData)) {
      // 1. Get current year-month string (e.g., "2026-07")
      const now = new Date();
      const currentMonthStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

      // 2. Find matching month data, or fallback to the latest month in the array
      const currentMonthData = 
        rawData.find(item => item.Month === currentMonthStr) || 
        rawData[rawData.length - 1];

      const apiValue = currentMonthData?.[valueField];

      // 3. Format as currency with thousands separators
      if (apiValue !== undefined && apiValue !== null) {
        displayValue = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(apiValue);
      }

    }
    
    else {
      // Fallback behavior for single-object arrays (like Net Profit)
      const apiValue = rawData?.[0]?.[valueField];
      displayValue = apiValue !== undefined && apiValue !== null ? apiValue : "";
    }
  }

  return (
    <div
      onClick={onClick}
      style={{
        background: `linear-gradient(135deg, #ffffff 30%, ${color} 100%)`,
        borderRadius: 14,
        padding: "16px 18px",
        border: "1px solid #f1f5f9",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        height: "80px",
        flexShrink: 0,
        minWidth: "150px", // Adjust this width value based on your UI preferences
        width: "max-content", // 2. Forces card to calculate size based on text length
        flexShrink: 0,
      }}
    >
      {loadingMap?.["Daily Sales"] ? (
        <div>loading</div>
      ) : (
        <div>
          {/* Top Section: Title & Icon */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 0,
            }}
          >
            <span
              style={{
                fontSize: 11,
                color: "#64748b",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                whiteSpace: "nowrap",
              }}
            >
              {title}
            </span>
            {/* <div style={{
          width: 32, height: 32, borderRadius: 8, background: `${color}12`,
          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, color: color, flexShrink: 0
        }}>
          {icon}
        </div> */}
          </div>

          {/* Middle Section: Value & Micro Sparkline Layout */}
          {/* ⬇️ CHANGED: Added width: "100%" to guarantee proper side-by-side distribution */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              gap: 10,
              width: "100%",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#0f172a",
                letterSpacing: "-0.5px",
                whiteSpace: "nowrap",
              }}
            >
              
                { displayValue}
              
              
            </div>

            {/* Tiny Spike Graph (Sparkline) */}
            {/* {graphData && (
          // ⬇️ CHANGED: Added width: "75px", minWidth: "75px", and flexShrink: 0 to stop mobile from crushing it to 0px
          <div style={{ width: "75px", minWidth: "75px", height: "32px", marginBottom: "4px", flexShrink: 0 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={graphData.map((val, idx) => ({ id: idx, value: val }))}>
                <Line 
                  type="monotone" 
                  dataKey="value" 
                  stroke={color} 
                  strokeWidth={1.75} 
                  dot={false} 
                  isAnimationActive={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )} */}
          </div>

          {/* Bottom Section: Trend Badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              whiteSpace: "nowrap",
            }}
          >
            {trend && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 2,
                  fontSize: 11,
                  fontWeight: 600,
                  color: isUp ? "#10b981" : "#ef4444",
                }}
              >
                <span>{isUp ? "▲" : "▼"}</span> {trend}
              </span>
            )}
            <span style={{ fontSize: 11, color: "#94a3b8" }}>{subtitle}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default KPICard;
